import { Injectable, inject } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from '@libs/vc-core-lib';
import { ICommentModel } from '../model/comment.model';
import { Observable } from 'rxjs';
import { IBookmarkModel } from '../model/bookmark.model';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class CommentService {
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _commentPath = 'comments';

    public save(model: ICommentModel): Observable<ICommentModel> {
        return this._httpClient.post<ICommentModel>(
            `${this._environment.APP.VC_COMMENT_BASE_URL}/${this._commentPath}`,
            model
        );
    }

    public reply(commentId: number, text: string): Observable<ICommentModel> {
        let params = new HttpParams();
        params = params.append('text', text);
        return this._httpClient.post<ICommentModel>(
            `${this._environment.APP.VC_COMMENT_BASE_URL}/${this._commentPath}/${commentId}/reply`,
            null,
            { params: params }
        );
    }

    public findTopLevelComments(group: string): Observable<ICommentModel[]> {
        let params = new HttpParams();
        params = params.append('group', group.toString());
        return this._httpClient.post<ICommentModel[]>(
            `${this._environment.APP.VC_COMMENT_BASE_URL}/${this._commentPath}/top-level-comments`,
            null,
            { params: params }
        );
    }

    public createBookmark(commentId: number): Observable<IBookmarkModel> {
        return this._httpClient.post<IBookmarkModel>(
            `${this._environment.APP.VC_COMMENT_BASE_URL}/${this._commentPath}/${commentId}/bookmarks`,
            null
        );
    }

    public deleteBookmark(bookmarkId: number): Observable<void> {
        return this._httpClient.delete<void>(
            `${this._environment.APP.VC_COMMENT_BASE_URL}/${this._commentPath}/bookmarks/${bookmarkId}`
        );
    }
}
